import { AxiosError } from 'axios'
import { useFeedback } from 'context'
import { useParamsSelector } from 'hooks'
import { useInfiniteQuery } from 'react-query'
import { ApiResponseTypes, LicenseServices } from 'services'
import { getNextPageParam } from 'utils/getNextParam'
import { useParams } from 'react-router-dom'
import { UseQueryOptionsTypes } from '../../queries.types'

export const useInfiniteGroupsBySchoolQuery = (
  options: UseQueryOptionsTypes | undefined = {}
) => {
  const params = useParamsSelector()

  const queryParams = options.useParams ? params.objParams : {}

  const { classId: groupId } = useParams()

  const { alert } = useFeedback()

  const { data, ...infiniteQuery } = useInfiniteQuery(
    ['/licenseManagement/user-groups/groupId/students', groupId, queryParams],
    (paginatedParams) =>
      LicenseServices.userGroups.id.students.paginated({
        params: {
          groupId,
          page: paginatedParams.pageParam,
          search: queryParams.search
        }
      }),
    {
      keepPreviousData: true,
      getNextPageParam,
      onError: (error: AxiosError<ApiResponseTypes<unknown>>) => {
        alert.showError(error.response?.data.message || error.message)
      },
      enabled: options.enabled
    }
  )

  return {
    data: data?.pages.flatMap((page) => page.data) || [],
    dataCount: data?.pages.flatMap((page) => page.pagination.dataCount)[0] || 0,
    ...infiniteQuery
  }
}
